import React from "react";
import "./Styles/Collection.css"

export default function Collection({collections}) {
    const collectionsURL = process.env.REACT_APP_API_BASE_URL+'/images/collections/';

    return (
        <div className="collection-container">
            {
                collections.map((x, index)=>{
                    return (
                        <div key={'collection'+index} className={"col col-"+x.columns} onClick={() => goToCollection(x.slug)}>
                            <div className="overlay"></div>
                            <img src={collectionsURL+x.image} alt={x.slug}/>
                            <div className="text">
                                <p>{x.name}</p>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

function goToCollection(slug) {
    window.location.href = "/collections/"+slug;
}